import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { Card } from './ui/Card';
export function ForWhoSection() {
  return <section className="py-20 bg-white" data-id="element-25">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-heading font-medium text-brand-dark mb-4" data-id="element-28">
            ¿Es este método para ti?
          </h2>
          <p className="text-brand-muted text-lg" data-id="element-29">
            No queremos que pierdas tu tiempo. Este método es exclusivo para un
            tipo específico de mujer.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-30">
          {/* For You */}
          <Card className="p-8 border-l-4 border-l-green-500 bg-green-50/30" data-id="element-31">
            <h3 className="text-2xl font-heading font-bold text-brand-dark mb-6 flex items-center" data-id="element-32">
              <CheckCircle2 className="w-8 h-8 text-green-500 mr-3" data-id="element-33" />
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-34">
              {['Eres una mujer latina en EE.UU. cansada de vivir al día.', 'Buscas una forma honesta y digna de generar ingresos desde casa.', 'Tienes un teléfono inteligente y conexión a internet.', 'Estás dispuesta a aprender una habilidad nueva (no necesitas experiencia).', 'Quieres pasar más tiempo con tu familia sin sacrificar tus ingresos.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-35">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-36" />
                  <span className="text-brand-dark/80" data-id="element-37">{item}</span>
                </li>)}
            </ul>
          </Card>

          {/* Not For You */}
          <Card className="p-8 border-l-4 border-l-red-500 bg-red-50/30" data-id="element-38">
            <h3 className="text-2xl font-heading font-bold text-brand-dark mb-6 flex items-center" data-id="element-39">
              <XCircle className="w-8 h-8 text-red-500 mr-3" data-id="element-40" />
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-41">
              {['Buscas una fórmula mágica para hacerte rica sin trabajar.', 'No tienes compromiso ni ganas de superarte.', 'Crees que todo en internet es una estafa.', 'Prefieres seguir quejándote de tu jefe en lugar de tomar acción.', 'No estás dispuesta a invertir $17 en tu propio futuro.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-42">
                  <XCircle className="w-5 h-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-43" />
                  <span className="text-brand-dark/80" data-id="element-44">{item}</span>
                </li>)}
            </ul>
          </Card>
        </div>
      </div>
    </section>;
}